import React, { useState, useEffect } from 'react'
import { T, Spinner, Avatar, probColor, tdColor } from '../ui'
import { getNFLBlowoutSpots } from '../api'

// Blowout Spots — games with blowout potential (big favorite), and the favored team's RB room.
// The angle: a big favorite runs the clock late, so the lead back piles up carries AND the
// backup gets real garbage-time work (+ goal-line looks if the starter rests). We flag the
// backup when he has a live anytime-TD prob. Research only.

function RbLine({ r, backup }) {
  if (!r) return null
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '7px 0' }}>
      <Avatar url={r.headshot} name={r.name} team={r.team} size={26} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <span style={{ fontSize: 13.5, fontWeight: 800 }}>{r.name}</span>
        <span style={{ fontSize: 10.5, color: T.muted, fontWeight: 700, marginLeft: 6 }}>{backup ? 'backup RB' : 'lead RB'}</span>
        {backup && <span style={{ fontSize: 10, fontWeight: 900, color: T.amber, background: 'rgba(245,165,36,0.14)',
          border: `1px solid ${T.amber}55`, borderRadius: 6, padding: '2px 7px', marginLeft: 7 }}>⚡ GARBAGE-TIME VALUE</span>}
      </div>
      <span style={{ fontFamily: T.mono, fontWeight: 900, fontSize: 15, color: tdColor((r.prob || 0) / 100) }}>
        {r.prob != null ? `${r.prob}%` : '—'}</span>
    </div>
  )
}

function SpotCard({ s, onPlayer }) {
  return (
    <div style={{ background: T.card, border: `1px solid ${s.backup_makes_sense ? `${T.amber}55` : T.border}`,
      borderRadius: 14, padding: '13px 15px', marginBottom: 10 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 18, fontWeight: 900 }}>{s.favored} <span style={{ color: T.green }}>-{s.spread}</span></span>
        <span style={{ fontSize: 12.5, color: T.muted, fontWeight: 700 }}>vs {s.underdog}</span>
        {s.total != null && <span style={{ fontSize: 12, color: T.muted, fontWeight: 700 }}>· O/U {s.total}</span>}
        {s.fav_implied != null && <span style={{ marginLeft: 'auto', fontSize: 12, fontWeight: 800, color: T.green, fontFamily: T.mono }}>
          {s.fav_implied} implied</span>}
      </div>
      <div style={{ fontSize: 11, color: T.faint, fontWeight: 600, margin: '7px 0 4px', lineHeight: 1.4 }}>{s.why}</div>
      <div style={{ borderTop: `1px solid ${T.border}`, marginTop: 4, paddingTop: 2 }}
        onClick={() => {}}>
        <div onClick={() => s.rb1 && onPlayer && onPlayer({ gsis_id: s.rb1.gsis_id, full_name: s.rb1.name, team: s.rb1.team, pos: 'RB', prop_type: 'anytime_td' })} style={{ cursor: 'pointer' }}>
          <RbLine r={s.rb1} backup={false} /></div>
        <div onClick={() => s.rb2 && onPlayer && onPlayer({ gsis_id: s.rb2.gsis_id, full_name: s.rb2.name, team: s.rb2.team, pos: 'RB', prop_type: 'anytime_td' })} style={{ cursor: 'pointer' }}>
          <RbLine r={s.rb2} backup={true} /></div>
      </div>
    </div>
  )
}

export default function BlowoutTab({ season = 2026, week = 1, onPlayer }) {
  const [d, setD] = useState(null)
  useEffect(() => { let a = true; setD(null)
    getNFLBlowoutSpots(season, week).then(r => { if (a) setD(r) }).catch(() => { if (a) setD({ spots: [] }) })
    return () => { a = false } }, [season, week])
  if (!d) return <div style={{ padding: 20 }}><Spinner /></div>
  const spots = d.spots || []
  return (
    <div style={{ padding: '12px 14px 90px' }}>
      <div style={{ fontSize: 12, color: T.muted, marginBottom: 12, lineHeight: 1.45 }}>
        Games with <b style={{ color: T.text }}>blowout potential</b> — a big favorite runs the clock late, so the lead back
        piles up carries and the <b style={{ color: T.amber }}>backup RB</b> gets garbage-time work (+ goal-line looks if the
        starter rests). We flag the backup when he has a live TD number. Research only.</div>
      {spots.length === 0
        ? <div style={{ fontSize: 12, color: T.muted, padding: '24px 0', textAlign: 'center' }}>
            No lopsided spreads this week — check back once lines firm up.</div>
        : spots.map((s, i) => <SpotCard key={s.game_id || i} s={s} onPlayer={onPlayer} />)}
    </div>
  )
}
